export default __webpack_public_path__ + "static/media/dayCare.7857d113.svg";